import * as moment from 'moment';
import { Trip } from '../../DataStructures/Trip/Trip';
export class TimeCounter {

    private started = false;
    private initialDay;
    private startingDate;
    private roundCounter = 0;
    public dayChanged = false;

    /**
     * Loops through the hours of the given day starting from 12:00 AM
     * @param currentDate 
     * @param numberOfRounds 
     */
    constructor(private currentDate: moment.Moment , private numberOfRounds: number = null) {

        this.init(currentDate);
    }

    private init(startDate) {
        this.started = false;
        this.currentDate = startDate;
        this.startingDate = this.currentDate.toLocaleString();
        this.initialDay = this.currentDate.day();
    }

    nextHour(): any {

        return this.count(true);
    }

    private count(next: boolean) {
        
        this.roundCounter++;
        if (this.started) {
            
            var fullDate = next ? moment(this.currentDate).add(1, 'h') : moment(this.currentDate).subtract(1, 'h');
            this.currentDate = fullDate;

            if (fullDate.day() != this.initialDay) {
                this.dayChanged = true;
            }

            if (this.numberOfRounds == null) {
                //The next day has come so counter should stop
                if (this.dayChanged) {
                    return -1;
                } else {
                    return Trip.createSubTripKey(fullDate);
                }
            } else {
                //The number of round has been reach so stop
                if (this.roundCounter - 1 > this.numberOfRounds) {
                    return -1;
                } else {
                    return Trip.createSubTripKey(fullDate);
                }
            }

        } else {
            this.started = true;
            return this.startingDate;
        }
    }

    lastHour(): any {
        return this.count(false);
    }
}